import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormatNumber, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import Loader from '../loader/loader';
import Label from '../label/Label';
import moment from 'moment';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const CreateSupplierExcelModal = ({ setDataExcel, visible = false, dataExcel, setVisible, fuctGet, isEdit }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const [dataRender, setDataRender] = useState([]);
    const addFlag = useRef(false);
    useEffect(() => {
        setDataRender(dataExcel);
    }, [dataExcel]);

    const handleEdit = () => {
        if (addFlag.current === true) return;
        addFlag.current = true;
        setFlagAddStat(true);

        const InVal = [];
        sendRequest(serviceList.insertExcelsupplier, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();
            setDataExcel([]);
            deleteTableExcel();
            setVisible(!visible);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out') + 2);
    };

    const deleteTableExcel = () => {
        const InVal = [];
        sendRequest(serviceList.deleteUploadsupplier, InVal, deleteExcelResult, true, timeOutDeleteTabbelExcel, 40000);
    };

    const deleteExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            setDataExcel([]);
        }
    };
    const timeOutDeleteTabbelExcel = (reqInfo) => {};

    const renderErr = (arrErr = []) => {
        let textErr = '';
        arrErr.map((err) => {
            textErr += ' ' + err;
        });
        return textErr;
    };

    return (
        <BootstrapDialog
            fullScreen
            open={visible}
            onClose={() => {
                deleteTableExcel();
                setDataExcel([]);
                setVisible(!visible);
            }}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {t('confirm_info')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Alert
                    sx={{ alignItems: 'flex-start', marginBottom: '20px', width: { md: '50%', sm: '100%' } }}
                    severity="warning"
                >
                    <div>
                        <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                            {t('note')}
                        </Typography>
                        <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                            {t('err_excel')}
                        </Typography>
                    </div>
                </Alert>
                <TableContainer>
                    <Table sx={{ paddingLeft: 2 }}>
                        {/* <UserListHead headLabel={TABLE_HEAD} /> */}
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ minWidth: '130px' }}>{t('code_supplier')}</TableCell>
                                <TableCell sx={{ minWidth: '170px' }}>{t('name_supplier')}</TableCell>
                                <TableCell sx={{ minWidth: '100px' }}>{t('producer')}</TableCell>
                                <TableCell sx={{ minWidth: '120px' }}>{t('persitional')}</TableCell>
                                <TableCell> {t('address_supplier')} </TableCell>
                                <TableCell sx={{ minWidth: '100px' }}>{t('phone_supplier')}</TableCell>
                                <TableCell sx={{ minWidth: '100px' }}>{t('Email')}</TableCell>
                                <TableCell sx={{ minWidth: '100px' }}>{t('note_')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataRender?.length > 0 &&
                                dataRender.map((item, index) => {
                                    {
                                        /* console.log(2121, item); */
                                    }
                                    return (
                                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                            <TableCell>{item[2]}</TableCell>
                                            <TableCell>{item[9]}</TableCell>
                                            <TableCell>{item[10][0]?.label}</TableCell>
                                            <TableCell>{item[3]}</TableCell>
                                            <TableCell>{item[6]}</TableCell>
                                            <TableCell>{item[5]}</TableCell>
                                            <TableCell>{item[4]}</TableCell>
                                            <TableCell align="left">
                                                <Typography color={item[8] !== 'ERR' ? 'text.success' : 'text.error'}>
                                                    {item[8] !== 'ERR' ? (
                                                        <Label color={'primary'}>{t('OK')}</Label>
                                                    ) : (
                                                        renderErr(item[7])
                                                    )}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        deleteTableExcel();
                        setDataExcel([]);
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CreateSupplierExcelModal;
